import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';

// Ensure axios is passed correctly to the constructor
const mock = new MockAdapter(axios);

export default mock;